export const MENU_PLACEHOLDER_ID =
	'software-backlog.card-list.card.card-contents.context-menu.menu_placeholder';

export const CARD_CONTAINER_SELECTOR = 'software-backlog-card-container';
